import React, { useState, useMemo } from "react";
import Swal from "sweetalert2";
import {
  useStripe,
  useElements,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";

const StripePaymentModal = ({ stripeModalData, onSuccess, onCancel }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);

  const {
    guest,
    monthly_rents = [],
    additional_items = [],
  } = stripeModalData || {};
console.log('stripeModalData', stripeModalData);
  // ✅ SAFE CALCULATIONS
  const {
    total_discount,
    total_rate,
    total_rate_discount,
    total_bed_charges,
    total_amount,
  } = useMemo(() => {
    let bedDiscount = 0;
    let itemsRate = 0;
    let itemsDiscount = 0;

    monthly_rents.forEach(r => {
      bedDiscount += Number(r.discount || 0);
    });

    additional_items.forEach(i => {
      itemsRate += Number(i.rate || 0);
      itemsDiscount += Number(i.discount || 0);
    });

    const months = monthly_rents.length;
    const monthlyRate = Number(guest?.monthly_rate || 0);

    const bedCharges = monthlyRate * months - bedDiscount;
    const totalAmount = bedCharges + (itemsRate - itemsDiscount);

    return {
      total_discount: bedDiscount,
      total_rate: itemsRate,
      total_rate_discount: itemsDiscount,
      total_bed_charges: bedCharges,
      total_amount: totalAmount,
    };
  }, [guest, monthly_rents, additional_items]);

  const submitPayment = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setLoading(true);

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardNumberElement),
    });

    if (error) {
      Swal.fire("Error", error.message, "error");
      setLoading(false);
      return;
    }

    onSuccess(paymentMethod.id);
  //  setLoading(false);
  };

  if (!guest) return null;

  return (
    <form onSubmit={submitPayment}>
      {/* ===== PAYMENT SUMMARY ===== */}
      <div className="border rounded-2 p-3 bg-light mb-4">
        <div className="row mb-2">
          <div className="col-sm-5 fw-bold">Name:</div>
          <div className="col-sm-7">{guest.name}</div>
        </div>

        <div className="row mb-2">
          <div className="col-sm-5 fw-bold">Email:</div>
          <div className="col-sm-7">{guest.email}</div>
        </div>

        <div className="row mb-2">
          <div className="col-sm-5 fw-bold">Bed Charges:</div>
          <div className="col-sm-7">
            ${guest.monthly_rate} × {monthly_rents.length} months = $
            {guest.monthly_rate * monthly_rents.length}
          </div>
        </div>

        <div className="row mb-2">
          <div className="col-sm-5 fw-bold">Bed Discount:</div>
          <div className="col-sm-7">${total_discount}</div>
        </div>

   {guest?.is_recurring &&
  <div className="row mb-2">
    <div className="col-sm-5 fw-bold">Auto-Pay:</div>
    <div className="col-sm-7 fw-bold">
       Charge <strong>${guest.monthly_rate * monthly_rents.length - total_discount}</strong> every {monthly_rents.length} {monthly_rents.length > 1 ? "months" : "month"}.
     
    </div>
  </div>
}

        <div className="row mb-2">
          <div className="col-sm-5 fw-bold">Additional Items:</div>
          <div className="col-sm-7">${total_rate}</div>
        </div>

        <div className="row mb-2">
          <div className="col-sm-5 fw-bold">Additional Discount:</div>
          <div className="col-sm-7">${total_rate_discount}</div>
        </div>
         

        <hr />

        <div className="row mb-2">
          <div className="col-sm-5 fw-bold">Total Amount:</div>
          <div className="col-sm-7 h5 mb-0">${total_amount}</div>
        </div>
      </div>

  

      {/* ===== CARD DETAILS ===== */}
      <div className="mb-3">
        <label className="form-label">Card Number</label>
        <CardNumberElement className="form-control p-2" />
      </div>

      <div className="row">
        <div className="col-md-6 mb-3">
          <label className="form-label">Expiry</label>
          <CardExpiryElement className="form-control p-2" />
        </div>
        <div className="col-md-6 mb-3">
          <label className="form-label">CVC</label>
          <CardCvcElement className="form-control p-2" />
        </div>
      </div>

      <div className="d-flex justify-content-end gap-3">
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button type="submit" className="btn btn-dark" disabled={loading}>
          {loading ? "Processing..." : `Pay $${total_amount}`}
        </button>
      </div>
    </form>
  );
};

export default StripePaymentModal;
